import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useKioskAuth } from "../context/KioskAuthContext";

const KioskPrivateRoute = ({ children }) => {
  const { kioskUser, kioskLoading } = useKioskAuth();
  const location = useLocation();

  if (kioskLoading) {
    return null;
  }

  if (!kioskUser) {
    return (
      <Navigate
        to="/kiosk/login"
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
};

export default KioskPrivateRoute;